(ns com.theplantscape.web-ui.svg.canvas
  (:require
   [com.theplantscape.conversions.core :refer [distance]]
   [com.theplantscape.plant-web.draw.canvas-actions :refer [action]]
   [com.theplantscape.plant-web.draw.events
    :as evt
    :refer [make-coords-xy ref-make-coords-xy]]
   [com.theplantscape.plant-web.draw.helpers :refer [get-millis]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state move-canvas reset-pointer site-state store-pointer-history]]
   [com.theplantscape.svg-generation.ensemble :refer [transform-origin]]
   [com.theplantscape.web-ui.svg.helpers :refer [ui-svg-root]]))

(defn fix-canvas-xy
  "Fix cordinates when page is scrolled"
  [evt]
  (let [bounds (.getBoundingClientRect (.-target evt))]
    [(- (.-pageX evt) (.-left bounds) js/window.scrollX)
     (- (.-pageY evt) (.-top bounds) js/window.scrollY)]
    [(.-clientX evt) (.-clientY evt)]))

(defn touch-start [action-fn root-ref translated-ref evt]
  (.preventDefault evt)
  (let [pointer-id (.-pointerId evt)
        xy-coords (fix-canvas-xy evt)
        start-pointer-id (get-in @app-state [:touch pointer-id :start :point])
        ;translated-xy (ref-make-coords-xy @root-ref @translated-ref (fix-canvas-xy evt))
        translated-xy (make-coords-xy xy-coords)]

    #_(when (nil?  (get-in @app-state [:touch]))
        (swap! app-state assoc-in [:touch-start]
               {:pointer-id  pointer-id
                :time (get-millis)}))

    (swap! app-state assoc-in [:pointer :current :pos] translated-xy)
    (swap! app-state assoc-in [:touch pointer-id :start]
           {:time (get-millis)
            :position {:client-xy xy-coords
                       :translated-xy translated-xy}
            :coords translated-xy})
    (swap! app-state assoc-in [:touch pointer-id :position]
           {:client-xy xy-coords
            :translated-xy translated-xy
            ;:coords translated-xy
            })

    (when (= 1 (count (get-in @app-state [:touch])))
      (swap! app-state assoc-in [:touch-start]
             {:pointer-id  pointer-id
              :time (get-millis)}))

    (case (count (-> @app-state :touch))
      1
      (action-fn :start translated-xy)
      2
      (swap! app-state assoc-in [:touch-distance]
             (distance translated-xy
                       (get-in @app-state [:touch start-pointer-id :start :coords])))

      (do (prn (str "No support for " (count (-> @app-state :touch)) " fingers"))
          (prn (-> @app-state :touch))))))

(defn coordinate-difference
  "Work out the difference of xy1 and xy2 multiply by a factor to account for zoom
  zoomed in should be a smaller movement than zoomed in
  move the canvas by calculated xy amount"
  [factor canvas-xy xy1 xy2]
  (->> (map - xy1 xy2)
       (map #(* factor %))
       (map + canvas-xy)))

(defn touch-move
  ([action-fn root-ref translated-ref evt]
   (.preventDefault evt)
   #_(swap! app-state assoc-in [:pointer :current :pos] (ref-make-coords-xy @root-ref @translated-ref (fix-canvas-xy evt)))
   (swap! app-state assoc-in [:pointer :current :pos] (make-coords-xy (fix-canvas-xy evt)))

   (when (> (+ (-> @app-state :touch-start :time) 10000) (get-millis))
     (let [pointer-id (.-pointerId evt)
           xy-coords (fix-canvas-xy evt)

           start-pointer-id (-> @app-state :touch-start :pointer-id)
           pointer-count (count (get-in @app-state [:touch]))
           translated-xy (make-coords-xy xy-coords)]

       (case pointer-count
         0 nil
         1
         (action-fn :update translated-xy)
         ;;(move-ob translated-xy)
         2
         (when (= pointer-id pointer-id #_start-pointer-id)
           (apply move-canvas
                  (coordinate-difference
                   (/ 1 (-> @app-state :canvas :zoom))
                   (-> @app-state  :canvas :pos)
                   (get-in @app-state [:touch pointer-id :position :client-xy])
                   xy-coords)))
         (do (prn (str "No support for " (count (-> @app-state :touch)) " fingers"))
             (prn (-> @app-state :touch))))
       (swap! app-state assoc-in [:touch pointer-id :position]
              {:client-xy xy-coords
               :translated-xy translated-xy
               :coords translated-xy})))))

(defn touch-end [action-ref root-ref translated-ref evt]
  (when-let [pointer-id (.-pointerId evt)]

    (when (> (+ (get-in @app-state [:touch pointer-id :start :time]) 10000) (get-millis))
      (prn "store history")
      (let [translated-xy (ref-make-coords-xy @root-ref @translated-ref (fix-canvas-xy evt))]
        (store-pointer-history translated-xy)))

    (swap! app-state update-in [:touch] dissoc pointer-id))

  (swap! app-state assoc-in [:touch-start :time] 0)
  #_(swap! app-state assoc-in [:touch :points] (.-length (.-touches evt)))
  (when (= 0 (count (get-in @app-state [:touch])))
    (swap! app-state assoc-in [:touch-start :pointer-id] nil)
    #_(swap! app-state assoc-in [:touch :start :point] nil)))

(defn add-key-events-handler [attribute-map handler]
  (merge attribute-map
         {:on-key-up (fn [evt]
                       (prn "key up")
                       (handler (.-key evt)))}))

(defn add-pointer-events
  ;([m] (add-pointer-events m #(action %) nil nil))
  ([m action-fn root-svg-element transformed-svg-element]
   (merge m
          {:on-blur #(swap! site-state assoc :diagram-focus false)
           :on-focus #(swap! site-state assoc :diagram-focus true)
           :on-pointer-move (partial touch-move action-fn root-svg-element transformed-svg-element)
           :on-pointer-up (partial touch-end action-fn root-svg-element transformed-svg-element)
           :on-pointer-cancel reset-pointer
           :on-pointer-down (partial touch-start action-fn root-svg-element transformed-svg-element)})))

(defn ui-svg-canvas
  ;([id transform svg-body] (ui-svg-canvas id action transform svg-body))
  ;([id action-fn transform svg-body] (ui-svg-canvas id action-fn nil transform svg-body))
  ([id action-fn shortcut-fn transform & body]
   (let [root-svg (atom nil)
         transform-svg (atom nil)
         svg-attributes (-> {:view-box (:view-box transform) #_(str "0 0 100% 100%")
                             :width "100%"
                             :height "100%"
                             :ref (fn get-canvas-ref [e] (reset! root-svg e))
                             :style (transform-origin {:clip-path "none" :margin "0px"
                                                       :background-color "#cccccc"
                                                       :overflow "hidden"
                                                       :height "100%"
                                       ;;:pointer-events "none"
                                       ;; touch acion prevents scroll of page by user when on this element
                                                       :touch-action "none"}
                                                      "50% 50%")}
                            (add-pointer-events action-fn root-svg transform-svg)
                            (add-key-events-handler shortcut-fn))]

     (fn [id action-fn shortcut-fn transform & body]
       (->
        (ui-svg-root
         id
         svg-attributes)
        (conj (into [:g#events-transform
                     {:ref #(reset! transform-svg %)
                      :transform (:transform transform)}]  body)))))))

